// Unfortunately we have to explicitly define each icon import function to make
// sure only that file is built. If we were to use a loop with variables, it
// will build every font awesome icon file in the library.
export const availableIcons = {
  // Plus
  plusSolid: import(`@fortawesome/pro-solid-svg-icons/faPlus.js`),
  plusRegular: import(`@fortawesome/pro-regular-svg-icons/faPlus.js`),
  plusLight: import(`@fortawesome/pro-light-svg-icons/faPlus.js`),
  // Circle
  circleSolid: import(`@fortawesome/pro-solid-svg-icons/faCircle.js`),
  circleRegular: import(`@fortawesome/pro-regular-svg-icons/faCircle.js`),
  circleLight: import(`@fortawesome/pro-light-svg-icons/faCircle.js`),
  // Plus Circle
  plusCircleSolid: import(`@fortawesome/pro-solid-svg-icons/faPlusCircle.js`),
  plusCircleRegular: import(`@fortawesome/pro-regular-svg-icons/faPlusCircle.js`),
  plusCircleLight: import(`@fortawesome/pro-light-svg-icons/faPlusCircle.js`),
  // Minus Circle
  minusCircleSolid: import(`@fortawesome/pro-solid-svg-icons/faMinusCircle.js`),
  minusCircleRegular: import(`@fortawesome/pro-regular-svg-icons/faMinusCircle.js`),
  minusCircleLight: import(`@fortawesome/pro-light-svg-icons/faMinusCircle.js`),
  // Check Circle
  checkCircleSolid: import(`@fortawesome/pro-solid-svg-icons/faCheckCircle.js`),
  checkCircleRegular: import(`@fortawesome/pro-regular-svg-icons/faCheckCircle.js`),
  checkCircleLight: import(`@fortawesome/pro-light-svg-icons/faCheckCircle.js`),
  // Check
  checkSolid: import(`@fortawesome/pro-solid-svg-icons/faCheck.js`),
  checkRegular: import(`@fortawesome/pro-regular-svg-icons/faCheck.js`),
  checkLight: import(`@fortawesome/pro-light-svg-icons/faCheck.js`),
  // Times Circle
  timesCircleSolid: import(`@fortawesome/pro-solid-svg-icons/faTimesCircle.js`),
  timesCircleRegular: import(`@fortawesome/pro-regular-svg-icons/faTimesCircle.js`),
  timesCircleLight: import(`@fortawesome/pro-light-svg-icons/faTimesCircle.js`),
  // Question Circle
  questionCircleSolid: import(`@fortawesome/pro-solid-svg-icons/faQuestionCircle.js`),
  questionCircleRegular: import(`@fortawesome/pro-regular-svg-icons/faQuestionCircle.js`),
  questionCircleLight: import(`@fortawesome/pro-light-svg-icons/faQuestionCircle.js`),
  // Exclamation Triangle
  exclamationTriangleSolid: import(`@fortawesome/pro-solid-svg-icons/faExclamationTriangle.js`),
  exclamationTriangleRegular: import(`@fortawesome/pro-regular-svg-icons/faExclamationTriangle.js`),
  exclamationTriangleLight: import(`@fortawesome/pro-light-svg-icons/faExclamationTriangle.js`),
  // Exclamation Triangle
  exclamationCircleSolid: import(`@fortawesome/pro-solid-svg-icons/faExclamationCircle.js`),
  exclamationCircleRegular: import(`@fortawesome/pro-regular-svg-icons/faExclamationCircle.js`),
  exclamationCircleLight: import(`@fortawesome/pro-light-svg-icons/faExclamationCircle.js`),
  //Check Square
  checkSquareSolid: import(`@fortawesome/pro-solid-svg-icons/faCheckSquare.js`),
  // Square Full
  squareFullSolid: import(`@fortawesome/pro-solid-svg-icons/faSquareFull.js`),
  squareFullRegular: import(`@fortawesome/pro-regular-svg-icons/faSquareFull.js`),
  squareFullLight: import(`@fortawesome/pro-light-svg-icons/faSquareFull.js`),
  // Spinner
  spinnerSolid: import(`@fortawesome/pro-solid-svg-icons/faSpinner.js`),
  spinnerRegular: import(`@fortawesome/pro-regular-svg-icons/faSpinner.js`),
  spinnerLight: import(`@fortawesome/pro-light-svg-icons/faSpinner.js`),
  // Copy
  copySolid: import(`@fortawesome/pro-solid-svg-icons/faCopy.js`),
  copyRegular: import(`@fortawesome/pro-regular-svg-icons/faCopy.js`),
  copyLight: import(`@fortawesome/pro-light-svg-icons/faCopy.js`),
  // Times
  timesSolid: import(`@fortawesome/pro-solid-svg-icons/faTimes.js`),
  timesRegular: import(`@fortawesome/pro-regular-svg-icons/faTimes.js`),
  timesLight: import(`@fortawesome/pro-light-svg-icons/faTimes.js`),
  // Play
  playSolid: import(`@fortawesome/pro-solid-svg-icons/faPlay.js`),
  playRegular: import(`@fortawesome/pro-regular-svg-icons/faPlay.js`),
  playLight: import(`@fortawesome/pro-light-svg-icons/faPlay.js`),

  // Pause
  pauseSolid: import(`@fortawesome/pro-solid-svg-icons/faPause.js`),
  pauseRegular: import(`@fortawesome/pro-regular-svg-icons/faPause.js`),
  pauseLight: import(`@fortawesome/pro-light-svg-icons/faPause.js`),
  // Pencil
  pencilSolid: import(`@fortawesome/pro-solid-svg-icons/faPencil.js`),
  pencilRegular: import(`@fortawesome/pro-regular-svg-icons/faPencil.js`),
  pencilLight: import(`@fortawesome/pro-light-svg-icons/faPencil.js`),
  // Trash
  trashSolid: import(`@fortawesome/pro-solid-svg-icons/faTrashAlt.js`),
  trashRegular: import(`@fortawesome/pro-regular-svg-icons/faTrashAlt.js`),
  trashLight: import(`@fortawesome/pro-light-svg-icons/faTrashAlt.js`),
  // Lock
  lockSolid: import(`@fortawesome/pro-solid-svg-icons/faLock.js`),
  lockRegular: import(`@fortawesome/pro-regular-svg-icons/faLock.js`),
  lockLight: import(`@fortawesome/pro-light-svg-icons/faLock.js`),
  // Angle Right
  angleRightSolid: import(`@fortawesome/pro-solid-svg-icons/faAngleRight.js`),
  angleRightRegular: import(`@fortawesome/pro-regular-svg-icons/faAngleRight.js`),
  angleRightLight: import(`@fortawesome/pro-light-svg-icons/faAngleRight.js`),
  // Angle left
  angleLeftSolid: import(`@fortawesome/pro-solid-svg-icons/faAngleLeft.js`),
  angleLeftRegular: import(`@fortawesome/pro-regular-svg-icons/faAngleLeft.js`),
  angleLeftLight: import(`@fortawesome/pro-light-svg-icons/faAngleLeft.js`),
  // Angle left
  angleDownSolid: import(`@fortawesome/pro-solid-svg-icons/faAngleDown.js`),
  angleDownRegular: import(`@fortawesome/pro-regular-svg-icons/faAngleDown.js`),
  angleDownLight: import(`@fortawesome/pro-light-svg-icons/faAngleDown.js`),

  //Angle Up
  angleUpLight: import(`@fortawesome/pro-light-svg-icons/faAngleUp.js`),

  // Angle Double Left
  angleDoubleLeftSolid: import(`@fortawesome/pro-solid-svg-icons/faAngleDoubleLeft.js`),
  angleDoubleLeftRegular: import(`@fortawesome/pro-regular-svg-icons/faAngleDoubleLeft.js`),
  angleDoubleLeftLight: import(`@fortawesome/pro-light-svg-icons/faAngleDoubleLeft.js`),
  // Angle Double Right
  angleDoubleRightSolid: import(`@fortawesome/pro-solid-svg-icons/faAngleDoubleRight.js`),
  angleDoubleRightRegular: import(`@fortawesome/pro-regular-svg-icons/faAngleDoubleRight.js`),
  angleDoubleRightLight: import(`@fortawesome/pro-light-svg-icons/faAngleDoubleRight.js`),
  // Info Circle
  infoCircleSolid: import(`@fortawesome/pro-solid-svg-icons/faInfoCircle.js`),
  infoCircleRegular: import(`@fortawesome/pro-regular-svg-icons/faInfoCircle.js`),
  infoCircleLight: import(`@fortawesome/pro-light-svg-icons/faInfoCircle.js`),
  // Calendar Alt
  calendarAltSolid: import(`@fortawesome/pro-solid-svg-icons/faCalendarAlt.js`),
  calendarAltRegular: import(`@fortawesome/pro-regular-svg-icons/faCalendarAlt.js`),
  calendarAltLight: import(`@fortawesome/pro-light-svg-icons/faCalendarAlt.js`),
  // Bars
  barsSolid: import(`@fortawesome/pro-solid-svg-icons/faBars.js`),
  barsRegular: import(`@fortawesome/pro-regular-svg-icons/faBars.js`),
  barsLight: import(`@fortawesome/pro-light-svg-icons/faBars.js`),
  // Asterisk
  asteriskSolid: import(`@fortawesome/pro-solid-svg-icons/faAsterisk.js`),
  asteriskRegular: import(`@fortawesome/pro-regular-svg-icons/faAsterisk.js`),
  asteriskLight: import(`@fortawesome/pro-light-svg-icons/faAsterisk.js`),
  // Search
  searchSolid: import(`@fortawesome/pro-solid-svg-icons/faSearch.js`),
  searchRegular: import(`@fortawesome/pro-regular-svg-icons/faSearch.js`),
  searchLight: import(`@fortawesome/pro-light-svg-icons/faSearch.js`),
  // Clock
  clockSolid: import(`@fortawesome/pro-solid-svg-icons/faClock.js`),
  clockRegular: import(`@fortawesome/pro-regular-svg-icons/faClock.js`),
  clockLight: import(`@fortawesome/pro-light-svg-icons/faClock.js`),
  // Thumbs Down
  thumbsDownSolid: import(`@fortawesome/pro-solid-svg-icons/faThumbsDown.js`),
  thumbsDownRegular: import(`@fortawesome/pro-regular-svg-icons/faThumbsDown.js`),
  thumbsDownLight: import(`@fortawesome/pro-light-svg-icons/faThumbsDown.js`),
  // Octagon
  octagonSolid: import(`@fortawesome/pro-solid-svg-icons/faOctagon.js`),
  octagonRegular: import(`@fortawesome/pro-regular-svg-icons/faOctagon.js`),
  octagonLight: import(`@fortawesome/pro-light-svg-icons/faOctagon.js`),
  // Ban
  banSolid: import(`@fortawesome/pro-solid-svg-icons/faBan.js`),
  banRegular: import(`@fortawesome/pro-regular-svg-icons/faBan.js`),
  banLight: import(`@fortawesome/pro-light-svg-icons/faBan.js`),
  // Flask
  flaskSolid: import(`@fortawesome/pro-solid-svg-icons/faFlask.js`),
  flaskRegular: import(`@fortawesome/pro-regular-svg-icons/faFlask.js`),
  flaskLight: import(`@fortawesome/pro-light-svg-icons/faFlask.js`),

  // Mobile
  mobileLight: import(`@fortawesome/pro-light-svg-icons/faMobile.js`),

  // Desktop
  desktopLight: import(`@fortawesome/pro-light-svg-icons/faDesktop.js`),
  // Desktop-Alt
  desktopAltLight: import(`@fortawesome/pro-light-svg-icons/faDesktopAlt.js`),

  // Long Arrow
  longArrowAltUpSolid: import(`@fortawesome/pro-solid-svg-icons/faLongArrowAltUp.js`),
  longArrowAltUpRegular: import(`@fortawesome/pro-regular-svg-icons/faLongArrowAltUp.js`),
  longArrowAltUpLight: import(`@fortawesome/pro-light-svg-icons/faLongArrowAltUp.js`),
  // Double Arrow (Exchange)
  exchangeAltSolid: import(`@fortawesome/pro-solid-svg-icons/faExchangeAlt.js`),
  exchangeAltRegular: import(`@fortawesome/pro-regular-svg-icons/faExchangeAlt.js`),
  exchangeAltLight: import(`@fortawesome/pro-light-svg-icons/faExchangeAlt.js`),

  // Star
  starSolid: import(`@fortawesome/pro-solid-svg-icons/faStar.js`),
  starRegular: import(`@fortawesome/pro-regular-svg-icons/faStar.js`),
  starLight: import(`@fortawesome/pro-light-svg-icons/faStar.js`),

  // Ellipsis Horizontal
  ellipsisHSolid: import(`@fortawesome/pro-solid-svg-icons/faEllipsisH.js`),
  ellipsisHRegular: import(`@fortawesome/pro-regular-svg-icons/faEllipsisH.js`),
  ellipsisHLight: import(`@fortawesome/pro-light-svg-icons/faEllipsisH.js`),

  // Cog
  cogSolid: import(`@fortawesome/pro-solid-svg-icons/faCog.js`),
  cogRegular: import(`@fortawesome/pro-regular-svg-icons/faCog.js`),
  cogLight: import(`@fortawesome/pro-light-svg-icons/faCog.js`),

  // newsPaper
  newspaperLight: import(`@fortawesome/pro-light-svg-icons/faNewspaper.js`),
  browserLight: import(`@fortawesome/pro-light-svg-icons/faBrowser.js`),
  filterLight: import(`@fortawesome/pro-light-svg-icons/faFilter.js`),
  playCircleLight: import(`@fortawesome/pro-light-svg-icons/faPlayCircle.js`),

  //external Link
  externalLinkLight: import(`@fortawesome/pro-light-svg-icons/faExternalLink.js`),

  //download arrow
  arrowToBottomLight: import(`@fortawesome/pro-light-svg-icons/faArrowToBottom.js`),

  //cloud upload
  cloudUploadLight: import(`@fortawesome/pro-light-svg-icons/faCloudUpload.js`),

  //cloud download
  cloudDownloadLight: import(`@fortawesome/pro-light-svg-icons/faCloudDownload.js`),

  //sliders-v
  slidersVLight: import(`@fortawesome/pro-light-svg-icons/faSlidersV.js`),

  //eye
  eyeLight: import(`@fortawesome/pro-light-svg-icons/faEye.js`),

  //youtube
  youtubeLight: import(`@fortawesome/free-brands-svg-icons/faYoutube.js`),

  // USD Circle
  usdCircleLight: import(`@fortawesome/pro-light-svg-icons/faUsdCircle.js`),

  // File
  fileLight: import(`@fortawesome/pro-light-svg-icons/faFile.js`),

  // Suitcase
  suitcaseLight: import(`@fortawesome/pro-light-svg-icons/faSuitcase.js`),

  // Social icons don't have types light/regular/solid so just set everything
  // to be of light type since that is the default.
  // Facebook Square
  facebookSquareLight: import(`./facebook-square.js`), // Pinterest
  pinterestLight: import(`./pinterest.js`), // Twitter
  twitterSquareLight: import(`./twitter-square.js`), // Telegram Plane
  telegramPlaneLight: import(`./telegram-plane.js`),

  storiesLight: import(`./stories.js`)
};
